<template>
  <div class="font-size-h2 text-footer">SITE DOES NOT EXIST.</div>
</template>

<script>
export default {
  name: 'NoSiteFound'
}
</script>
